<template>
  <div class="border-t border-cockpit-line my-5" />
</template>
